/**
 * loadBalancer模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const loadBalancer = {
  //分页
  pageLoadBalancer(params) {
    return $http.post(`${global.API_URL}/sme/loadBalancer/page`,params);
  },
  //详情
  getLoadBalancerDetails(params) {
    return $http.post(`${global.API_URL}/sme/loadBalancer/getLoadBalancerDetails`,params);
  },
  //根据账户查询负载均衡
  queryLoadBalancerListByAccount(params) {
    return $http.post(`${global.API_URL}/sme/loadBalancer/queryLoadBalancerListByAccount`,params);
  },
  // 删除
  deleteLoadBalancer(id,params) {
    let param = new URLSearchParams()
    param.append(id, params)
    return $http.post(`${global.API_URL}/sme/loadBalancer/delete`,param);
  }
}

export default loadBalancer;



// WEBPACK FOOTER //
// ./src/api/loadBalancer.js